var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cwp-newsletter"},[_c('cwp-generic-form',{attrs:{"container":_vm.container,"submit-text":"Join the newsletter","persist-heading":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }